import { render, staticRenderFns } from "./AwemeList.vue?vue&type=template&id=7ab80f3f&scoped=true"
import script from "./AwemeList.vue?vue&type=script&lang=js"
export * from "./AwemeList.vue?vue&type=script&lang=js"
import style0 from "./AwemeList.vue?vue&type=style&index=0&id=7ab80f3f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab80f3f",
  null
  
)

export default component.exports